$(() => {
  if ($('#settings-card').length) {
    const hash = location.hash.replace(/^#/, '');
    if (hash) {
        $(`button[data-bs-target="#settings-${hash}"]`).tab('show');
    }

    $('button[role="tab"]').on('shown.bs.tab', (e) => {
        window.location.hash = e.target.dataset.bsTarget.replace(/^#settings-/, '#');
    });
  }
});
